import { InstructorPublicLayout, InstructorPrivateLayout } from "layouts";
import publicRoutes from "./public.route";
import privateRoutes from "./private.route";

/**
 * Generates the route configuration for the admin section of the application.
 * @param {Function} t - Translation function used for localization.
 * @returns {Array} An array with two route objects.
 * @function adminRoutes
 */
export const instructorRoutes = (t) => {
  return [
    {
      element: <InstructorPublicLayout />,
      children: [...publicRoutes(t)],
    },
    {
      element: <InstructorPrivateLayout />,
      children: [...privateRoutes(t)],
    },
  ];
};
